// extracted by mini-css-extract-plugin
export default {"container":"modal_confirmation_container-module__container--4eNQj","overlay":"modal_confirmation_container-module__overlay--hf0Le"};